import React from 'react'
import { useHistory } from 'react-router-dom'
import { Button } from '@material-ui/core'
import { AuthContainer } from 'containers'
import { Alert } from 'components'
import { getPageCondition } from 'utils/utilities'
import { SUPPLIER_REPORT_PAGES } from 'constants/pages'

export type ViewReportsButtonProps = {
  buttonText?: string
  reportFileName?: string
}

export const ViewReportsButton: React.FC<ViewReportsButtonProps> = (props: ViewReportsButtonProps) => {
  const { buttonText, reportFileName } = props
  const history = useHistory()

  const { userType, selectedSupplier } = AuthContainer.useContainer()
  const [open, setOpen] = React.useState(false)

  const viewReportsPageCondition = SUPPLIER_REPORT_PAGES.find((page) =>
    page.routeTo.includes('/supplier/reports')
  )?.condition
  const pageCondition = getPageCondition({ condition: viewReportsPageCondition, userType, selectedSupplier })

  return (
    <>
      <Button
        variant="text"
        className={`text-primary underline normal-case text-lg`}
        onClick={() => {
          pageCondition.enabled
            ? history.push(`/supplier/reports${reportFileName ? `?reportFileName=${reportFileName}` : ''}`)
            : setOpen(true)
        }}
      >
        {buttonText ?? 'View Reports'}
      </Button>
      {open && (
        <Alert
          title={buttonText ?? 'View Reports'}
          open={open}
          onClose={() => setOpen(false)}
          message={pageCondition.message ?? 'This page is disabled!'}
          onConfirm={() => {
            setOpen(false)
          }}
        />
      )}
    </>
  )
}
